import Vue from 'vue'
import Vuex from 'vuex'
import pers from 'vuex-persistedstate'
import getters from './getters'

Vue.use(Vuex)

const state ={
	username:null
}

const mutations = {
	addsession(state,userinfo){
		state.username = userinfo
	}
}
const actions = {
 
}

const modules = {
	
}

export default new Vuex.Store({
	plugins:[pers()],
  state,
  mutations,
  actions,
	getters,
  modules
})
